module.exports = __webpack_public_path__ + "media/images/download/e-book04-ede3772bfd991f295460011f36f33ffc.png";